import { render, staticRenderFns } from "./price_add.vue?vue&type=template&id=68d627fc&"
import script from "./price_add.vue?vue&type=script&lang=ts&"
export * from "./price_add.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports